import { GAME_VARIANT_LABEL_MAP } from "@/src/constants/StatsCornerConstants";
import styles from "../Stats.module.css";
import gameAssets from "@themed-assets";
import { formatINRNumber } from "../../../../Common/utils/statsUtil";
import { isA23 } from "../Stats";

export const PlayedStakesInfo = ({ item, index, mostPlayedStakes }) => {
  return (
    <>
      <div
        className={`variant-blind-hands-info flex justify-between items-center`}
      >
        <div className="variant-blind-info flex items-center gap-1">
          <div className={`${styles.variantLabel}`}>
            {GAME_VARIANT_LABEL_MAP[item?.gameVariant]?.shortLabel}
          </div>
          <img src={gameAssets.ChipsStackIcon} />
          <div className={`blinds-info font-medium text-xs text-primary`}>
            {item?.smallBlind}/{item?.bigBlind}
          </div>
        </div>
        <div className="hands-info text-xs font-normal  text-secondary">
          {formatINRNumber(item?.noOfHands)} Hands
        </div>
      </div>
      {index < mostPlayedStakes.length - 1 && (
        <div
          className={`${
            isA23 ? styles.gradientSeaBorder : styles.addaCardBorder
          }`}
        ></div>
      )}
    </>
  );
};
